import Api from "services/Api";
import _ from "lodash";

export const mutationTypes = {
  RESET: "RESET",
  UPDATE_USER: "UPDATE_USER",
  UPDATE_TOKEN: "UPDATE_TOKEN",
  ERROR: "ERROR",
  NO_ERROR: "NO_ERROR",
  LOCKED: "LOCKED",
  LOCKED_ERRORS: "LOCKED_ERRORS"
};

function userTemplate() {
  return {
    id: null,
    fullName: null,
    firstName: null,
    lastName: null,
    email: null,
    token: null,
    loginToken: null,
    hideNames: false
  };
}

// Initial State
const state = {
  user: userTemplate(),
  token: null,
  error: false,
  locked: false,
  lockedErrors: null
};

// Getters
const getters = {
  getUser: state => state.user,
  getUserId: state => state.user.id || null,
  getUserFullName: state => state.user.fullName || null,
  getUserFirstName: state => state.user.firstName || null,
  getUserLastName: state => state.user.lastName || null,
  getUserEmail: state => state.user.email || null,
  getToken: state => state.token || null,
  getLoginToken: state => state.user.loginToken || null,
  hasError: state => state.error,
  hasLockedErrors: state => state.lockedErrors,
  isLocked: state => state.locked,
  hideNames: state => state.user.hideNames,
  showNames: state => !state.user.hideNames
};

// Actions
const actions = {
  /**
   * Authenticate a user.
   */
  loginUser: _.debounce(({ commit }, { email, password }) => {
    commit(mutationTypes.RESET);

    return Api.users.login({ email, password }).then(response => {
      if (response.success) {
        commit(mutationTypes.NO_ERROR);
        commit(mutationTypes.UPDATE_USER, { user: response.user });
        commit(mutationTypes.UPDATE_TOKEN, { token: response.token });
        return;
      }

      commit(mutationTypes.ERROR, true);
    });
  }, 500),

  /**
   * Logout a user
   */
  logoutUser: _.debounce(({ commit }) => {
    return Api.users.logout().then(data => {
      commit(mutationTypes.RESET);
    });
  }, 500),

  /**
   * Check a users logged in status
   */
  authenticateUser: _.debounce(({ commit }, authenticate) => {
    return Api.users
      .authenticate({ authenticate })

      .then(response => {
        if (response.success) {
          commit(mutationTypes.NO_ERROR);
          commit(mutationTypes.UPDATE_USER, { user: response.user });
          commit(mutationTypes.UPDATE_TOKEN, { token: response.token });

          window.location = "/";
          return;
        }

        commit(mutationTypes.ERROR, true);
        window.location = "/";
      });
  }, 500),

  /**
   * Authenticate a user from a locked state.
   */
  continueUser: _.debounce(({ commit }, { email, password }) => {
    return Api.users.login({ email, password }).then(response => {
      if (response.success) {
        commit(mutationTypes.NO_ERROR);
        commit(mutationTypes.UPDATE_USER, { user: response.user });
        commit(mutationTypes.UPDATE_TOKEN, { token: response.token });
        commit(mutationTypes.LOCKED_ERRORS, null);
        return;
      }

      commit(mutationTypes.LOCKED_ERRORS, response);
    });
  }, 500),

  /**
   * Timeout Lock The Screen
   *
   * @param  commit
   */
  lock({ commit }) {
    commit(mutationTypes.LOCKED);
  },

  /**
   * Reset Errors
   *
   * @param  commit
   */
  resetErrors({ commit }) {
    commit(mutationTypes.ERROR, null);
  },

  /**
   * Reset User
   *
   * @param  commit
   */
  resetUser({ commit }) {
    commit(mutationTypes.RESET);
  }
};

// Mutations
const mutations = {
  [mutationTypes.UPDATE_USER](state, { user }) {
    state.user.id = user.id;
    state.user.firstName = user.first_name;
    state.user.lastName = user.last_name;
    state.user.fullName = user.full_name;
    state.user.email = user.email;
    state.user.loginToken = user.login_token;
    state.user.hideNames = false;
    state.locked = false;
  },
  [mutationTypes.UPDATE_TOKEN](state, { token }) {
    state.token = token;
  },
  [mutationTypes.ERROR](state, error) {
    state.error = error;
  },
  [mutationTypes.LOCKED_ERRORS](state, response) {
    state.lockedErrors = response;
  },
  [mutationTypes.NO_ERROR](state) {
    state.error = false;
  },
  [mutationTypes.LOCKED](state) {
    state.locked = true;
    state.token = null;
  },
  [mutationTypes.RESET](state) {
    state.user = userTemplate();
    state.token = null;
    state.error = false;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/user/index.js